// extracted by mini-css-extract-plugin
module.exports = {"root":"root_3_3Fq"};